export function formatBillingMethod(value?: string) {
  switch (value) {
    case 'DirectBill':
      return 'Direct Bill';
    case 'AgencyBill':
      return 'Agency Bill';
    default:
      return value;
  }
}
